import { axios } from "../config/axios";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";
import {
  ICreateVoucherCode,
  IEditVoucherCode,
  IVoucherCode
} from "../interfaces/endpoints/IVoucherCode";
import { serialize } from "../utils/serializeToQueryString";

export type GetAllVoucherCodesParamsType = {
  searchKeyword?: string;
};

export const getAllVoucherCodes = async (
  params: GetAllVoucherCodesParamsType
): Promise<IAxiosResponse<IVoucherCode[]>> => {
  return axios.get<IVoucherCode[]>(`/v1/VoucherCode${serialize(params)}`);
};

export const getVoucherCodeById = async (
  id: number
): Promise<IAxiosResponse<IVoucherCode>> => {
  return axios.get(`/v1/VoucherCode/${id}`);
};

export const createVoucherCode = async (
  body: ICreateVoucherCode
): Promise<IAxiosResponse<IVoucherCode>> => {
  return axios.post("/v1/VoucherCode", body);
};

export const updateVoucherCode = async (
  id: number,
  body: IEditVoucherCode
): Promise<IAxiosResponse<IVoucherCode>> => {
  return axios.put(`/v1/VoucherCode/${id}`, body);
};

export const deleteVoucherCode = async (id: number): Promise<boolean> => {
  return axios.delete(`/v1/VoucherCode/${id}`);
};
